import {create} from 'zustand';

export const useAllStore = create((set) => ({
    interactionFlag: false,
    popstateButton: false,
    headerHeight: 56,

    handleUserInteraction: () =>
        set({interactionFlag: true}),

    setPopstateButton: (state = false) =>
        set({popstateButton: state}),

    setHeight: (height) =>
        set({headerHeight: height}),
}));
